/**
 * Google Map
 *
 * This component requires jQuery and Slick to function.
 * You can require it on the page using <div data-component="map"></div>
 */
import 'assets/scripts/maps';
$(function () {
  $('[data-component="map"]').each(function () {
    let $holder = $(this);
    $holder.maps({
      map: {
        disableDefaultUI: true,
        zoomControl: true
      },
      infobox: {
        closeBoxMargin: '-15px -15px 0px 0px',
        closeBoxURL: 'https://www.google.com/intl/en_us/mapfiles/close.gif'
      }
    });
  });
});